// //import { bootstrapApplication } from '@angular/platform-browser';
// import { appConfig } from './app/app.config';
// import { App } from './app/app';

// bootstrapApplication(App, appConfig)
//   .catch((err) => console.error(err));

import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app/app.routes'; // Ajusta la ruta si es necesario
import { provideClientHydration } from '@angular/platform-browser';
import { AppComponent } from './app/app';

import 'zone.js'; // 👈 Necesario para Angular

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withFetch()),
    provideClientHydration(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled', // 👈 habilita scroll automático
        scrollPositionRestoration: 'enabled', // restaura posición al navegar
      })
    ), // 👈 Esto activa la rehidratación
  ],
}).catch((err) => console.error(err));
